import { render } from "./QuizForm.vue?vue&type=template&id=ee2ccf40&ts=true"
import script from "./QuizForm.vue?vue&type=script&lang=ts"
export * from "./QuizForm.vue?vue&type=script&lang=ts"

import "./QuizForm.vue?vue&type=style&index=0&id=ee2ccf40&lang=scss"

import exportComponent from "C:\\Users\\artur\\Documents\\CODELEX\\2 - CODELEX\\JOB SEARCH\\COMPANY ASSIGNMENTS\\Printful\\frontend-quiz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__